import React, { PropTypes } from 'react'

import VenueSearchResult from './venue-search-result'

const VenueSearchResults = ({ handleSelectVenue, results }) => (
  <div>
    {results.map((result, i) =>
      <VenueSearchResult
        address1={result.address1}
        address2={result.address2}
        handleSelect={() => handleSelectVenue(result)}
        key={i}
        name={result.name}
        postalCode={result.postalCode}
      />
    )}
  </div>
)

VenueSearchResults.propTypes = {
  handleSelectVenue: PropTypes.func,
  results: PropTypes.array,
}

export default VenueSearchResults



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/venue-search/venue-search-results/venue-search-results.js
 **/